import { Component, input, computed } from '@angular/core';
import { CrawlerStatus } from '../../../../../../models/integration/crawler';

export interface SingleCrawlerCountry {
  code: string;
  name: string;
}

// info card at the top of the single-crawler view
@Component({
  selector: 'app-single-crawler-summary-card',
  templateUrl: './single-crawler-summary-card.component.html',
  styleUrls: ['./single-crawler-summary-card.component.scss'],
})
export class SingleCrawlerSummaryCardComponent {
  readonly name = input('');
  readonly url = input<string>();
  readonly frequencyLabel = input('');
  readonly countries = input<SingleCrawlerCountry[]>([]);
  readonly searchDepth = input<number>();
  readonly maxPages = input<number>();
  readonly status = input<CrawlerStatus | undefined>();

  // for app-territories
  readonly territories = computed(() => this.countries()
    .map((c) => c.code));
}
